import axios from 'axios';
import qs from 'qs';

export default {
    props: {
        memberId: {
            type: Number,
            required: true,
        },
    },

    render() {
        return this.$scopedSlots.default({
            openMailTo: this.openMailTo,
        });
    },
    methods: {
        async openMailTo(token) {
            const url = '/actions/team-members-module/default/verify';

            const postData = {
                token,
                memberId: this.memberId,
                [this.$global.csrfTokenName]: this.$global.csrfTokenValue,
            };

            try {
                const { data: { email } } = await axios.post(url, qs.stringify(postData));

                window.location.href = `mailto:${email}`;
            } catch (err) {
                // eslint-disable-next-line no-alert
                alert('There was a problem verifying that you aren\'t a robot');
            }
        },
    },
};
